import { render, staticRenderFns } from "./wbdp-ad-add-miss-return-list.vue?vue&type=template&id=9adfcde0"
import script from "./wbdp-ad-add-miss-return-list.vue?vue&type=script&lang=js"
export * from "./wbdp-ad-add-miss-return-list.vue?vue&type=script&lang=js"
import style0 from "./wbdp-ad-add-miss-return-list.vue?vue&type=style&index=0&id=9adfcde0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports